import { defineStore } from 'pinia'

import { useOAuthStore } from 'src/stores/oauth.js'

import {
  createFilter,
  deleteFilter,
  fetchFilters,
  updateFilter,
} from 'src/api/filters.js'
import {
  asLocalFilters,
  PLACES,
} from 'src/services/server_filters/server_filters.js'

const credentials = () => useOAuthStore().token

// The user's word filters from this browser and from the server that
// apply in a place, for muteFilterHits; a null place means local ones only
export const allMuteFilters = (localFilters, place) => [
  ...Object.values(localFilters ?? {}),
  ...(place ? useServerFiltersStore().byPlace[place] : []),
]

// The user's keyword filters on the server.
export const useServerFiltersStore = defineStore('serverFilters', {
  state: () => ({
    filters: [],
    loaded: false,
  }),
  getters: {
    // for each place, the filters that apply there, shaped like the local
    // word filters; computed once per change of the filters
    byPlace: (state) =>
      Object.fromEntries(
        PLACES.map((place) => [place, asLocalFilters(state.filters, place)]),
      ),
  },
  actions: {
    async load() {
      const { data } = await fetchFilters({ credentials: credentials() })
      this.filters = data
      this.loaded = true
    },
    async add(filter) {
      const { data } = await createFilter({
        credentials: credentials(),
        filter,
      })
      this.filters = [...this.filters, data]
    },
    async change(id, filter) {
      const { data } = await updateFilter({
        credentials: credentials(),
        id,
        filter,
      })
      this.filters = this.filters.map((f) => (f.id === id ? data : f))
    },
    async remove(id) {
      await deleteFilter({ credentials: credentials(), id })
      this.filters = this.filters.filter((f) => f.id !== id)
    },
  },
})
